import React from "react";

const SmallEditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M1.54167 11.4583H2.55104L9.475 4.53437L8.46562 3.525L1.54167 10.449V11.4583ZM0.125 12.875V9.86458L9.475 0.532292C9.61667 0.402431 9.77309 0.302083 9.94427 0.23125C10.1155 0.160417 10.2955 0.125 10.4844 0.125C10.6733 0.125 10.8562 0.160417 11.0333 0.23125C11.2104 0.302083 11.3639 0.408333 11.4938 0.55L12.4677 1.54167C12.6094 1.67153 12.7127 1.825 12.7776 2.00208C12.8425 2.17917 12.875 2.35625 12.875 2.53333C12.875 2.72222 12.8425 2.90226 12.7776 3.07344C12.7127 3.24462 12.6094 3.40104 12.4677 3.54271L3.13542 12.875H0.125ZM8.96146 4.03854L8.46562 3.525L9.475 4.53437L8.96146 4.03854Z"
        fill="#007EB5"
      />
    </svg>
  );
};

export default SmallEditIcon;
